export const siteInfo = {
  name: '爱情岛',
  tagline: '浪漫邂逅与心动体验的专属乐园',
  description: '爱情岛，专为情侣打造的浪漫目的地，汇聚心动约会攻略、蜜月旅行灵感与独特爱情体验。无论是初恋的悸动还是长久陪伴的温柔，爱情岛带你感受最真实的浪漫时光，开启属于两个人的专属旅程。',
  url: 'https://aiqingdao.com',
  logo: '爱情岛',
  foundingYear: 2018,
  email: 'hello@aiqingdao.com',
  phone: '400-888-1314',
  address: '浙江省杭州市西湖区龙井路99号',
  socialLinks: {
    weibo: 'https://weibo.com/aiqingdao',
    wechat: 'aiqingdao_official',
    xiaohongshu: 'https://xiaohongshu.com/aiqingdao',
    douyin: 'https://douyin.com/aiqingdao',
  },
  stats: {
    articles: 1280,
    destinations: 360,
    couples: 50000,
    satisfaction: 98.6,
  },
};

export const brandStory = {
  title: '关于爱情岛',
  subtitle: '让每一段爱情，都拥有属于自己的岛屿',
  paragraphs: [
    '爱情岛创立于2018年，是中国领先的情侣旅行内容平台。我们相信，每一对恋人都值得拥有一段独一无二的浪漫旅程。从最初的个人博客到如今的综合性浪漫旅行指南，爱情岛已经陪伴超过50,000对情侣找到了属于他们的心动目的地。',
    '我们的团队由资深旅行达人、专业摄影师和情感专栏作家组成，足迹遍布全球360多个浪漫目的地。每一篇攻略、每一张照片、每一个推荐，都经过实地体验和精心筛选，只为给你最真实、最有温度的旅行灵感。',
    '在爱情岛，我们不仅分享旅行攻略，更传递一种生活方式——用旅行滋养爱情，用仪式感点亮日常。无论你们是刚刚牵手的初恋情侣，还是相濡以沫多年的老夫老妻，都能在爱情岛找到属于你们的浪漫篇章。',
  ],
};

export const brandValues = [
  {
    icon: 'ri-heart-pulse-line',
    title: '真实体验',
    description: '每一处推荐都经过团队实地探访，拒绝虚假宣传，只分享真心喜欢的目的地和体验。',
  },
  {
    icon: 'ri-compass-3-line', 
    title: '深度探索',
    description: '不止于表面打卡，我们挖掘每个目的地的故事、文化和隐藏的浪漫角落。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '品质保证',
    description: '严格筛选合作伙伴，确保推荐的酒店、餐厅和体验项目都达到高品质标准。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '以情侣的真实需求为核心，提供个性化、可操作的旅行建议和灵感。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨 & 阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20asian%20couple%20portrait%20smiling%20happily%20together%20in%20romantic%20setting%2C%20warm%20sunset%20light%2C%20soft%20focus%2C%20natural%20and%20intimate%20photography%20style%2C%20warm%20cream%20background&width=120&height=120&seq=testimonial-avatar-01&orientation=squarish',
    text: '跟着爱情岛的攻略去了大理，在洱海边度过了一个无比浪漫的周末。每一篇攻略都写得特别用心，感觉像是朋友在跟你分享秘密基地！',
    rating: 5,
    destination: '大理洱海',
  },
  {
    id: 2,
    name: '思涵 & 明哲',
    avatar: 'https://readdy.ai/api/search-image?query=Lovely%20asian%20couple%20portrait%20laughing%20together%20outdoor%20sunny%20day%2C%20casual%20romantic%20vibe%2C%20soft%20natural%20lighting%2C%20gentle%20expression%2C%20warm%20creamy%20background&width=120&height=120&seq=testimonial-avatar-02&orientation=squarish',
    text: '蜜月旅行的灵感全部来自爱情岛！从巴厘岛到圣托里尼，攻略详细到连餐厅的靠窗位置都帮你标注好了，简直是情侣旅行的百科全书。',
    rating: 5,
    destination: '巴厘岛蜜月',
  },
  {
    id: 3,
    name: '晓雯 & 建豪',
    avatar: 'https://readdy.ai/api/search-image?query=Happy%20asian%20couple%20portrait%20with%20gentle%20smile%20romantic%20atmosphere%2C%20elegant%20casual%20style%2C%20warm%20indoor%20lighting%2C%20intimate%20mood%2C%20cream%20soft%20background&width=120&height=120&seq=testimonial-avatar-03&orientation=squarish',
    text: '作为直男的我以前完全不会策划约会，自从关注了爱情岛，每次约会女友都惊喜得不行。约会攻略那栏简直就是宝藏！',
    rating: 5,
    destination: '城市约会',
  },
];

export const faqs = [
  {
    question: '爱情岛是什么？',
    answer: '爱情岛是中国领先的情侣旅行内容平台，致力于为情侣和新婚夫妇提供高质量的约会攻略、蜜月旅行灵感和独特的浪漫体验推荐。',
  },
  {
    question: '如何选择适合自己的浪漫目的地？',
    answer: '你可以根据预算、季节、旅行时长和个人偏好在我们的分类页面中筛选。我们也提供详细的攻略文章，包含交通、住宿、美食和拍照打卡等全方位信息。',
  },
  {
    question: '爱情岛的推荐是否可靠？',
    answer: '我们的每一篇攻略都由专业团队实地体验后撰写，所有推荐均基于真实体验。我们坚持独立客观的评测标准，不因商业合作而影响推荐质量。',
  },
  {
    question: '可以定制专属的浪漫旅行方案吗？',
    answer: '目前我们通过内容平台提供灵感与攻略参考。如果你需要一对一的旅行定制服务，可以通过联系我们页面提交需求，我们的旅行顾问会与你沟通。',
  },
  {
    question: '如何在爱情岛投稿分享自己的旅行故事？',
    answer: '我们欢迎情侣读者分享自己的浪漫旅行经历！你可以通过联系页面或发送邮件至我们的官方邮箱提交稿件，优质内容将有机会被收录并在平台展示。',
  },
];